// Library Imports
import React, { useContext } from 'react'
import { Container, Row, Col } from 'react-bootstrap'

// Component Imports
import PageBanner from '../../components/banner/PageBanner'
import AdvancedSearch from '../../components/search/AdvancedSearch'
import CategoryFilter from '../../components/filter/CategoryFilter'
import ListSort from '../../components/sort/ListSort'
import ListingGrid from './ListingGrid'

// Context Imports
import { ListProvider } from '../../contexts/ListContext'
import { DirectoryContext } from '../../contexts/DirectoryContext'

function Listings() {
    const {
        inputSearchText,
        inputLocation,
        inputSubCategory,
        inputCategory
    } = useContext(DirectoryContext);

    return (
        <>
            <div className='listingspage'>
                <PageBanner pageName="Listings" />
                <ListProvider
                    startCategory={inputCategory}
                    startSearchText={inputSearchText}
                    startLocation={inputLocation}
                    startSubCategory={inputSubCategory}>
                    <Container className='my-3'>
                        <Row>
                            <Col xs={12} sm={12} md={4} lg={3} xl={3}>
                                <CategoryFilter />
                                <AdvancedSearch />
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={9} xl={9}>
                                <ListSort />
                                <ListingGrid />
                            </Col>
                        </Row>
                    </Container>
                </ListProvider>
            </div>
        </>
    )
}

export default Listings